module.exports = __webpack_public_path__ + "static/media/L2.f696396d.png";